module.exports = __webpack_public_path__ + "img/f2.e740b83a.png";